import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { userManager } from "../auth/oidcConfig";
import { SetContextLink } from "@apollo/client/link/context";

const GRAPHQL_URL =
  import.meta.env.VITE_GRAPHQL_URL ||
  "https://snt-stage.fg.se/api/gateway/graphql";

const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
});

const authLink = new SetContextLink(async ({ headers }) => {
  let user = await userManager.getUser();

  if (!user || user.expired) {
    try {
      user = await userManager.signinSilent();
    } catch (err) {
      console.warn("Silent sign-in failed:", err);
    }
  }

  const token = user?.access_token;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Invoice: {
        fields: {
          // These nested objects carry no id, so Apollo would replace rather
          // than merge them. List and detail queries deliberately select
          // different subsets of each, and without a merge the narrower write
          // would evict the other query's fields and force it to refetch.
          state: { merge: true },
          invoiceIssuer: { merge: true },
          invoiceRecipient: { merge: true },
          latestAssessment: { merge: true },
        },
      },
    },
  }),
});
